import { graphql } from "@opensea/graphql"

export const TransferFlowTimeline_itemFragment = graphql(`
  fragment TransferFlowTimeline_item on Item {
    id
    tokenId
    chain {
      identifier
    }
    contractAddress
  }
`)
